<template>
  <div class="table-wrapper scrollable" :class="name+'-table'">
    <div class="table-content">
      <ul class="table-head">
        <li class="row thead">
          <ul>
            <li class="column" v-for="key in columns" :key="key" :class="key">
              <p v-if="key === 'uid'">{{$t('dash.table.title.analytics')}}</p>
              <p v-else-if="key === 'admin'">{{$t('dash.table.title.permission')}}</p>
              <p v-else>{{$t('dash.table.title.'+key)}}</p>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="table-body scrollable">
        <li class="row" v-for="(entry, index) in gridData" :key="index" :data-qa="name === 'custom-sources' ? `list-sources-${entry.name}`: ''" :class="[{'story': name === 'overview' && entry.page && entry.page[0] && entry.page[0].story, 'direct-removed': entry.page && entry.page[0] && entry.page[0].insightsError}]">
          <Tooltip :active="name === 'overview' && entry.page && entry.page.length && !!entry.page[0].insightsError" :text="$t(`dash.insights.direct-removed`)" position="top" style="width: 100%;">
            <ul>
              <li class="column" v-for="key in columns" :key="key" :class="key">
                <ul v-if="key === 'pages' && name === 'custom-sources'">
                  <li v-for="(bot, index) in entry.pages" :key="index" @click="goToBot(bot.id)" :class="[{'hide': !checkUserPageAccess(bot.page.id)}]">
                    <Tooltip :text="bot.page.name" position="top">
                      <page-image-avatar :page="bot.page" />
        
                    </Tooltip>
                  </li>
                  <li class="add" @click="openUpdateBots(entry)">
                    <Tooltip :text="$t('dash.sources.affected-to-pages')" position="top">
                      <i class="material-icons">add_circle_outline</i>
        
                    </Tooltip>
                  </li>
                </ul>
                <ul v-if="key === 'pages' && name === 'users'">
                  <li v-for="(page, index) in entry.pages_access.slice(0,3)" :key="index" >
                    <Tooltip :text="page.name" position="top">
                      <page-image-avatar :page="page"/>
        
                    </Tooltip>
                  </li>
                  <li class="add" @click="openUpdatePagesAccess(entry)">
                    <Tooltip :text="$t('dash.user.add-pages-access')" position="top">
                      <i class="material-icons">add_circle_outline</i>
        
                    </Tooltip>
                  </li>
                </ul>
                <div v-else-if="key === 'pages' && name !== 'overview'">
                  <page-image-avatar :page="entry._bots[0].page" v-if="entry._bots && entry._bots[0]"/>
                </div>

                <div v-else-if="key === 'pages' && name === 'overview'">
                  <Tooltip :text="entry._bots.find(b => entry.page[0].id && b.uid == entry.page[0].id).page.name" position="top" v-if="entry._bots && entry._bots.find(b => entry.page[0].id && b.uid == entry.page[0].id)">
                    <page-image-avatar :page="entry._bots.find(b => entry.page[0].id && b.uid == entry.page[0].id).page"/>  
      
                  </Tooltip>
                </div>

                <div v-else-if="key === 'source'" class="cell">
                  <p v-if="entry.flux && entry.flux.source && entry.flux.source.name">{{entry.flux.source.name}}</p>
                  <p v-else-if="sources && sources.find(s => entry.flux && s.uid == entry.flux.id)" :data="sources.find(s => entry.flux && s.uid == entry.flux.id).name" class="column source">
                    {{sources.find(s => entry.flux && s.uid == entry.flux.id).name}}
                  </p>
                  <p v-else data="Custom" class="column source">Custom</p>
                </div>

                <div v-else-if="key === 'when' && entry.page && entry.page[0]" class="cell">
                  <p>{{ formatDate(entry.page[0].posted_date) }}</p>
                </div>

                <div v-else-if="key === 'type-source' && name === 'custom-sources'">
                  <p class="txt">{{$t(`dash.sources.${entry.type || 'rss'}-source`)}}</p>
                </div>

                <div v-else-if="key === 'content-source' && name === 'custom-sources'">
                  <p class="txt" v-if="!entry.type || entry.type == 'rss'">{{entry.url}}</p>
                  <p class="txt" v-else>{{entry.custom_field}}</p>
                </div>

                <div v-else-if="key === 'content' && name !== 'overview'" class="cell">
                  <div class="thumb-wrapper">
                    <img class="thumb" :src="entry[key].img">
                  </div>
                  <div class="txt-wrapper">
                    <p>{{entry[key].txt}}</p>
                  </div>
                </div>
                <div v-else-if="key === 'content' && name === 'overview'" class="cell">
                  <div class="thumb-wrapper">
                    <img v-if="entry.page[0].network == 'instagram' && entry.page[0].story && getScreenshot(entry)" class="thumb" :src="getScreenshot(entry)" @error="replaceByDefault">
                    <img v-else-if="entry._bots.find(b => entry.page[0].id && b.uid == entry.page[0].id).mode === 'story' && (entry.screenshot || entry.page[0].enclosure)" class="thumb" :src="entry.screenshot || entry.page[0].enclosure" @error="replaceByDefault">
                    <img v-else-if="entry.enclosure != null && entry.enclosure != ''" class="thumb" :src="entry.enclosure" @error="replaceByDefault">
                    <video v-else-if="entry.page && entry.page[0] && entry.page[0].video" :src="entry.page[0].video"></video>
                    <img v-else class="thumb" :meta="getMetaOgImage(entry, `meta-image-${entry.id}`, index)" :ref="`meta-image-${entry.id}`" @error="replaceByDefault">
                  </div>
                  <div class="txt-wrapper">
                    <p v-html="getText(entry)"></p>
                  </div>
                </div>

                <div v-else-if="key === 'stats'">
                  <ul class="sources" v-if="entry.page && entry.page[0] && entry.page[0].insights && entry.page[0].insights.length && entry.page[0].network == 'facebook' && !entry._bots.find(b => entry.page[0].id && b.uid == entry.page[0].id).page.isGroup">
                    <li>
                      <Tooltip
                        :text="entry.page[0].insights.find(i => ['fb_reels_total_plays',].includes(i.name)) ? $t('dash.reporting.total_read') : $t('dash.reporting.impression')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
                        <p>{{ entry.page[0].insights.find(i => ['post_media_view', 'total_video_impressions', 'fb_reels_total_plays', 'total_video_impressions'].includes(i.name)) ? entry.page[0].insights.find(i => ['post_media_view', 'total_video_impressions', 'fb_reels_total_plays', 'total_video_impressions'].includes(i.name)).values[0].value : 0 }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.reaction')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                        <p v-if="entry.page[0].insights.find(i => ['post_reactions_like_total', 'total_video_reactions_by_type_total'].includes(i.name))">{{ entry.page[0].video ? sumReaction(entry.page[0].insights.find(i => ['post_reactions_like_total', 'total_video_reactions_by_type_total'].includes(i.name)).values[0].value) : entry.page[0].insights.find(i => ['post_reactions_like_total', 'total_video_reactions_by_type_total'].includes(i.name)).values[0].value }}</p>
                        <p v-else-if="entry.page[0].insights.find(i => ['post_video_likes_by_reaction_type'].includes(i.name))">{{ sumReaction(entry.page[0].insights.find(i => ['post_video_likes_by_reaction_type'].includes(i.name)).values[0].value) || 0 }}</p>
                        <p v-else>0</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="entry.page[0].insights.find(i => ['post_video_social_actions'].includes(i.name)) ? $t('dash.reporting.pdf.comments') : $t('dash.reporting.clic')"
                        position="top"
                      >
                        <img v-if="entry.page[0].insights.find(i => ['post_video_social_actions'].includes(i.name))" class="icon-white" src="../../assets/img/rss/icon_comments.svg" alt="comments">
                        <img v-else class="icon-white" src="../../assets/img/rss/icon_clicks.svg" alt="clicks">
                        <p v-if="entry.page[0].insights.find(i => ['post_clicks', 'total_video_views_clicked_to_play', 'total_video_views_clicked_to_play'].includes(i.name))">{{ entry.page[0].insights.find(i => ['post_clicks', 'total_video_views_clicked_to_play', 'total_video_views_clicked_to_play'].includes(i.name)).values[0].value }}</p>
                        <p v-else-if="entry.page[0].insights.find(i => ['post_video_social_actions'].includes(i.name))">{{ entry.page[0].insights.find(i => ['post_video_social_actions'].includes(i.name)).values[0].value.COMMENT }}</p>
                        <p v-else>0</p>
                      </Tooltip>
                    </li>
                    <li><vs-button class="btn-large show" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button></li>
                  </ul>
                  <ul class="sources" v-else-if="entry.page && entry.page[0] && entry.page[0].insights && entry.page[0].insights.length && entry.page[0].network == 'instagram' && !entry._bots.find(b => entry.page[0].id && b.uid == entry.page[0].id).page.isGroup">
                    <li v-if="entry.page[0].insights.find(i => ['views'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.impression')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
                        <p>{{ entry.page[0].insights.find(i => ['views'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights.find(i => ['likes'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.reaction')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                        <p>{{ entry.page[0].insights.find(i => ['likes'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights.find(i => ['comments'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.pdf.comments')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_comments.svg" alt="comments">
                        <p>{{ entry.page[0].insights.find(i => ['comments'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights.find(i => ['shares'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.pdf.shares')"
                        position="top"
                      >
                        <img class="icon-white shares" src="../../assets/img/rss/icon_shares.svg" alt="shares">
                        <p>{{ entry.page[0].insights.find(i => ['shares'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights.find(i => ['saved'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.pdf.saved')"
                        position="top"
                      >
                        <img class="icon-white saved" src="../../assets/img/rss/icon_saved.svg" alt="saved">
                        <p>{{ entry.page[0].insights.find(i => ['saved'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <!-- STORY -->
                    <li v-if="entry.page[0].insights && entry.page[0].insights[0] && entry.page[0].insights[0].insights && entry.page[0].insights[0].insights.data && entry.page[0].insights[0].insights.data.find(i => ['views'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.impression')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="views">
                        <p>{{ entry.page[0].insights[0].insights.data.find(i => ['views'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights && entry.page[0].insights[0] && entry.page[0].insights[0].insights && entry.page[0].insights[0].insights.data && entry.page[0].insights[0].insights.data.find(i => ['replies'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.replies')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_comments.svg" alt="replies">
                        <p>{{ entry.page[0].insights[0].insights.data.find(i => ['replies'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights && entry.page[0].insights[0] && entry.page[0].insights[0].insights && entry.page[0].insights[0].insights.data && entry.page[0].insights[0].insights.data.find(i => ['shares'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.pdf.shares')"
                        position="top"
                      >
                        <img class="icon-white shares" src="../../assets/img/rss/icon_shares.svg" alt="shares">
                        <p>{{ entry.page[0].insights[0].insights.data.find(i => ['shares'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights && entry.page[0].insights[0] && entry.page[0].insights[0].insights && entry.page[0].insights[0].insights.data && entry.page[0].insights[0].insights.data.find(i => ['follows'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.follows')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="follows">
                        <p>{{ entry.page[0].insights[0].insights.data.find(i => ['follows'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li v-if="entry.page[0].insights && entry.page[0].insights[0] && entry.page[0].insights[0].insights && entry.page[0].insights[0].insights.data && entry.page[0].insights[0].insights.data.find(i => ['navigation'].includes(i.name))">
                      <Tooltip
                        :text="$t('dash.reporting.navigation')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_clicks.svg" alt="navigation">
                        <p>{{ entry.page[0].insights[0].insights.data.find(i => ['navigation'].includes(i.name)).values[0].value }}</p>
                      </Tooltip>
                    </li>
                    <li><vs-button class="btn-large show" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button></li>
                  </ul>
                  <ul class="sources" v-else-if="entry.page && entry.page[0] && entry.page[0].insights && entry.page[0].network == 'twitter'">
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.impression')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
                        <p>{{ entry.page[0].insights.impression_count }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.posts.retweet')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_retweet.svg" alt="retweet">
                        <p>{{ entry.page[0].insights.retweet_count }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.reaction')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                        <p>{{ entry.page[0].insights.like_count }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.pdf.comments')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_comments.svg" alt="comments">
                        <p>{{ entry.page[0].insights.reply_count }}</p>
                      </Tooltip>
                    </li>
                    <li><vs-button class="btn-large show" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button></li>
                  </ul>
                  <ul class="sources" v-else-if="entry.page && entry.page[0] && entry.page[0].insights && entry.page[0].network == 'linkedin'">
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.impression')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
                        <p>{{ entry.page[0].insights.totalShareStatistics.impressionCount }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.reaction')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                        <p>{{ entry.page[0].insights.totalShareStatistics.likeCount }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.pdf.comments')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_comments.svg" alt="comments">
                        <p>{{ entry.page[0].insights.totalShareStatistics.commentCount }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.pdf.shares')"
                        position="top"
                      >
                        <img class="icon-white shares" src="../../assets/img/rss/icon_shares.svg" alt="shares">
                        <p>{{ entry.page[0].insights.totalShareStatistics.shareCount }}</p>
                      </Tooltip>
                    </li>
                    <li>
                      <Tooltip
                        :text="$t('dash.reporting.clic')"
                        position="top"
                      >
                        <img class="icon-white" src="../../assets/img/rss/icon_clicks.svg" alt="clicks">
                        <p>{{ entry.page[0].insights.totalShareStatistics.clickCount }}</p>
                      </Tooltip>
                    </li>
                    <li><vs-button class="btn-large show" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button></li>
                  </ul>
                  <ul class="sources" v-else-if="entry.page && entry.page[0] && ['facebook', 'linkedin', 'twitter', 'instagram'].includes(entry.page[0].network)">
                    <li v-if="entry.page[0].insightsError || (entry.page[0].insights && entry.page[0].insights.length == 0)"><p>N/A</p></li>
                    <li v-else class="insights-loading"><i class="material-icons">sync</i></li>
                    <li class="absolute-right" v-if="entry.page[0].insightsError">
                      <vs-button class="btn-large show" @click="showPost(entry)">
                        {{ $t('dash.posts.view' )}}
                      </vs-button>
                    </li>
                    <li class="absolute-right" v-else><vs-button class="btn-large show" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button></li>
                  </ul>
                  <ul class="sources" v-else-if="entry.page && entry.page[0] && ['threads', 'bluesky', 'pinterest', 'google', 'youtube'].includes(entry.page[0].network)">
                    <li class="absolute-right"><vs-button class="btn-large show" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button></li>
                  </ul>
                </div>
                
                <!-- <div v-else-if="key === 'show'">
                  <vs-button class="btn-large show" v-if="entry.page && entry.page[0] && ['facebook', 'linkedin', 'twitter', 'threads', 'bluesky', 'pinterest', 'google', 'youtube'].includes(entry.page[0].network)" @click="showPost(entry)">{{ $t('dash.posts.view' )}}</vs-button>
                </div> -->

                <div v-else-if="key === 'status'">
                  <p class="sources-status" v-if="name === 'custom-sources'">
                    <template v-if="entry.status">
                        <vs-avatar
                          color="transparent"
                          size="18px"
                          :src="
                            require('../../assets/img/icon_check_light.svg')
                          "
                          @click="findNewsParsed(entry)"
                        />
                        <span>&nbsp;</span>
                      <span class="ok">{{ `${!entry.to_fetch_at ? $t('dash.sources.status_running') : `${$t('dash.sources.to_fetch_at')} ${formatDate(entry.to_fetch_at)}`}` }}</span>
                    </template>
                    <template v-else>
                        <vs-avatar
                          color="transparent"
                          size="18px"
                          :src="require('../../assets/img/icon_stop.svg')"
                          @click="confirmEnable(entry.id)"
                        />
                        <a
                          href="#"
                          @click="confirmEnable(entry.id)"
                          v-html="$t('dash.sources.enable')"
                        ></a>
                      <p>{{ `${$t('dash.sources.status_error')} : ${entry.error}` }}</p>
                    </template>
                  </p>
                </div>

                <div v-else-if="key === 'actions'">
                  <vs-button
                    v-if="name === 'invoice'"
                    color="#a9a9a9"
                    vs-type="border"
                    size="large"
                    type="submit"
                    @click="download(index)"
                  >{{$t('dash.button.download')}}</vs-button>
                  <vs-button
                    v-if="name === 'users' || name === 'bots'"
                    color="#a9a9a9"
                    vs-type="border"
                    size="large"
                    type="submit"
                    @click="edit(entry.id)"
                  >{{$t('dash.button.edit')}}</vs-button>
                  <Tooltip :text="$t(`dash.button.delete`)" position="top" v-if="(name === 'users' && (!entry.admin || gridData.filter(e => e && e.admin).length > 1)) || name === 'custom-sources'">
                    <vs-button
                      size="large"
                      type="submit"
                      class="delete-btn"
                      @click="remove(entry.id)"
                    >
                      <i class="material-icons">close</i>
                    </vs-button>
      
                  </Tooltip>
                  <vs-button
                    v-if="name === 'suggested-sources'"
                    color="#a9a9a9"
                    vs-type="border"
                    size="large"
                    type="submit"
                    @click="remove(index)"
                  >{{$t('dash.button.botremove')}}</vs-button>
                </div>

                <div v-else-if="key === 'admin'">
                  <p class="txt">{{ $t(`dash.settings.user.${getUserRole(entry)}`) }}
                    <span v-if="getUserRole(entry) == 'Viewer'" @click="getViewerLoginUrl(entry.id)" class="link">
                      {{ $t(`dash.settings.user.viewer.url`) }}
                    </span>
                  </p>
                </div>

                <div v-else>
                  <template v-if="name === 'custom-sources' && key == 'name'">
                    <Tooltip :text="$t(`dash.sources.${entry.type || 'rss'}-source`)" position="top">
                      <img v-if="!entry.type || entry.type == 'rss'"
                        src="../../assets/img/rss-source.svg"
                        alt="rss"
                      />
                      <img v-else-if="entry.type == 'google-news'"
                        src="../../assets/img/google-news-source.svg"
                        alt="google-news"
                      />
                      <!-- <img v-else-if="entry.type == 'youtube'"
                        src="../../assets/img/youtube-source.svg"
                        alt="youtube-source"
                      /> -->
                      <img v-else-if="entry.type == 'youtube'"
                        src="../../assets/img/logo-youtube.svg"
                        alt="youtube-source"
                      />
                      <img v-else-if="entry.type == 'vimeo'"
                        src="../../assets/img/vimeo-source.svg"
                        alt="vimeo-source"
                      />
                      <img v-else-if="entry.type == 'dailymotion'"
                        src="../../assets/img/dailymotion-source.svg"
                        alt="dailymotion-source"
                      />
                      <img v-else-if="entry.type == 'pinterest'"
                        src="../../assets/img/pinterest-source.svg"
                        alt="pinterest-source"
                      />
                      <img v-else-if="entry.type == 'twitter'"
                        src="../../assets/img/twitter-source.svg"
                        alt="twitter-source"
                      />
        
                    </Tooltip>
                    <p class="txt link" @click="edit(entry.id)">
                      {{entry[key]}}
                    </p>
                  </template>
                  <p v-else class="txt">{{entry[key]}}</p>
                </div>
              </li>
            </ul>
          </Tooltip>
        </li>
      </ul>
    </div>
    <vs-popup :class="`sidebar-action list-news`":title="$t('dash.sources.to_fetch_at')" :active.sync="showListNews">
      <ul>
        <li v-for="(news, index) in listNews" :key="index">
          <a :href="news.url" target="_blank">
            <div class="wrapper">
              <img :src="news.enclosure" v-if="news.enclosure" />
            </div>
            <p>
              <span class="date">{{ formatDate(news.published_at) }}</span>
              {{ news.title }}
            </p>
          </a>
        </li>
      </ul>
    </vs-popup>
  </div>
</template>

<script>
import moment from 'moment'
import Popup from '../../utils/Popup'
import imgDefault from '../../assets/img/no-picture.png'
import Posts from './../mixins/Posts'
import User from './../mixins/User'
import Notif from './../mixins/Notif'
import PageImageAvatar from './PageImageAvatar.vue'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  name: 'component-table',

  components: {
    PageImageAvatar,
    Tooltip
  },

  mixins: [Posts, User, Notif],

  props: {
    columns: Array,
    gridData: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },

  data(){
    return {
      version: localStorage.getItem('version_') || 'beta',
      excludeDomain: [],
      sources: [],
      listNews: [],
      showListNews: false
    }
  },

  mounted(){
    this.sources = localStorage.sources && JSON.parse(localStorage.sources) ? JSON.parse(localStorage.sources) : []
  },

  methods: {

    sumReaction(reactions) {
      let sum = 0
      for(let index in reactions)
        sum += reactions[index]
      return sum
    },

    getUserRole(user) {
      if(user.admin)
        return 'Administrator'
      else {
        if(user.role && user.role.length)
          return user.role[0]
        return 'Editor'
      }
    },

    getViewerLoginUrl(id) {
      this.getViewerUrl(id).then(res => {
        if(res.body && res.body.success && res.body.url) {
          this.copyViewerUrl(res.body.url)
          // notif copy en presse papier 
          this.notify({
            time: 10000,
            title: this.$t('dash.notifications.success_title'),
            text: this.$t('dash.settings.user.viewer_url.copy'), // L'url d'accès à été copier dans votre presse papier
            color:'success',
            id: 'norepeat'
          })
        }
        else {
          // notif error
          this.notify({
            time: 10000,
            title: this.$t('dash.notifications.error_title'),
            text: this.$t('dash.settings.user.viewer_url.failed'),
            color:'success',
            id: 'norepeat'
          })
        }
      })
    },

    copyViewerUrl(url) {
      const el = document.createElement('textarea');  
      el.value = url;                                 
      el.setAttribute('readonly', '');                
      el.style.position = 'absolute';                     
      el.style.left = '-9999px';                      
      document.body.appendChild(el);                  
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
      el.select();                                    
      document.execCommand('copy');                   
      document.body.removeChild(el);                  
      if (selected) {                                 
        document.getSelection().removeAllRanges();    
        document.getSelection().addRange(selected);   
      }
    },

    findNewsParsed(feed) {
      this.listNewsParsed(feed.uid).then(res => {
        console.log('findNewsParsed', res.body)
        if(res.body.news){
          this.showListNews = true
          this.listNews = res.body.news
        }
      })
    },

    getText(entry){

      let text = entry._bots && entry._bots.post_text_layout == 'description' ? entry.description : entry.title

      if(!text) text = ""

      //replace mention affected
      let count = 100;
      while(text.includes('@[') && count > 0){
        count -= 1;
        let start = text.indexOf('@[')
        if (start === -1) break;

        let end = text.indexOf(']', start)
        if (end === -1) break;

        let mention = {
          network: entry.page[0].network,
          value: text.substr(start, end-start+1)
        }
        if(mention) 
          switch(mention.network){
            case 'twitter':
            case 'instagram':
              mention = mention.value
              break
            case 'facebook':
            case 'linkedin':
              const inner = mention.value.substring(2, mention.value.length - 1)
              const paren = inner.lastIndexOf('(')
              let name
              if (paren === -1) {
                name = inner.trim()
              } else {
                name = inner.substring(0, paren).trim()
              }
              mention = `${name}`
              break
            default:
          }
        text = text.substr(0, start) + (mention ? mention : '') + text.substr(end+1)
      }

      if(text && text.length > 280)
        text = text.substr(0, text.substr(0, 280 - 4).lastIndexOf(" ")) + " ..."
      
      if(text && text.length > 280)
        text = text.substr(0, text.substr(0, 280 - 4).lastIndexOf(" ")) + " ..."
        
      return text
    },

    getMetaOgImage(post, ref, index){
      if(post.url){
        setTimeout(() => {
          if(!post.url.includes('topito.com')){
            this.getNewsMeta(post.url).then(res => {
              const { meta } = res.body
              if(meta && meta.og && meta.og.image){
                if(this.$refs[ref] && this.$refs[ref][0])
                  this.$refs[ref][0].src = meta.og.image
              }
            })
          }
          else if(this.$refs[ref] && this.$refs[ref][0])
            this.$refs[ref][0].src = imgDefault
        }, index*200)
      }
    },

    getScreenshot(entry) {
      if(entry.page[0] && entry.page[0].story && JSON.parse(entry.page[0].story)){
        let storyObj = JSON.parse(entry.page[0].story)
        if(storyObj.screenshot)
          return storyObj.screenshot
      }
      return null
    },

    replaceByDefault(e) {
      e.target.src = imgDefault
    },

    /**
     * Download action on click
     * @param {Number} index - Index invoice to download
     */
    download(index) {
      this.$emit('action-clicked', index)
    },
    /**
     * Edit action on click
     * @param {Number} index - Index invoice to download
     */
    edit(id) {
      this.$emit('edit', id)
    },
    /**
     * Delete action on click
     * @param {Number} index - Id to remove
     */
    remove(id) {
      this.$emit('remove', id)
    },
    /**
     * Add to bot on click
     * @param {Number} index - Id to remove
     */
    addToBot(id) {
      this.$emit('addToBot', id)
    },

    openUpdateBots(source) {
      this.$emit('openUpdateBots', source)
    },

    openUpdatePagesAccess(user) {
      this.$emit('openUpdatePagesAccess', user)
    },

    goToBot(bot){
      this.$emit('goToBot', bot)
    },

    /**
     * Enable source on click
     * @param {Number} id - Id to remove
     */
    confirmEnable(id){
      this.$emit('confirmEnable', id)
    },

    formatDate(dateToFormat) {
      let format = moment(dateToFormat)
        .local()
        .format('DD/MM/YY HH:mm')
      return format
    },

    showPost(post){
      switch(post._bots.find(b => b.uid == post.page[0].id).page.network){
        case 'facebook':
          this.openFacebook(post)
          break
        case 'instagram':
          this.openInstagram(post)
          break
        case 'twitter': 
          this.openTweet(post)
          break
        case 'linkedin': 
          this.openLinkedin(post)
          break
        case 'pinterest':
          this.openPinterest(post)
          break
        case 'google':
          this.openGoogle(post)
          break
        case 'youtube':
          this.openYoutube(post)
          break
        case 'threads':
          this.openThreads(post)
          break
        case 'bluesky':
          this.openBluesky(post)
          break
        default:
      }
    },

    openTweet(entry){
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://www.twitter.com/${username}/status/${entry.page[0].post_number}`, '', 900, 700)
    },

    openInstagram(entry){
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://www.instagram.com/${username}`, '', 900, 700)
    },

    openLinkedin(entry) {
      if (entry.page[0].post_number_bis) {
        Popup.open(`https://www.linkedin.com/feed/update/${entry.page[0].post_number_bis}`, '', 900, 700);
      } else {
        this.getLinkedinPost(entry._bots[0].page.id, entry.page[0].post_number).then(async res => {
          const { success, post } = res.body
          if(success && post && post.activity)
            Popup.open(`https://www.linkedin.com/feed/update/${post.activity}`, '', 900, 700)
          else if(success && post && post.id)
            Popup.open(`https://www.linkedin.com/feed/update/${post.id}`, '', 900, 700)
        })
      }
      
    },

    openThreads(entry) {
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://www.threads.net/@${username}`, '', 900, 700)

      // this.getThreadsPost(entry._bots[0].page.id, entry.page[0].post_number).then(async res => {
      //   const { success, post } = res.body
      //   if(success && post && post.permalink)
      //     Popup.open(post.permalink, '', 900, 700)
      // })
    },

    openBluesky(entry) {
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://bsky.app/profile/${username}/post/${entry.page[0].post_number.split('/').pop()}`, '', 900, 700)
    },

    openFacebook(entry) {
      Popup.open(`https://www.facebook.com/${entry.page[0].post_number}`, '', 900, 700)
    },

    openPinterest(entry){
      Popup.open(`https://www.pinterest.fr/pin/${entry.page[0].post_number}`, '', 900, 700)
    },

    openGoogle(entry){
      if(entry.page[0].post_number_bis)
        Popup.open(entry.page[0].post_number_bis, '', 900, 700)
      else {
        this.getGooglePost(entry._bots[0].page.id, entry.page[0].post_number).then(async res => {
          const { success, searchUrl } = res.body
          if(success && searchUrl)
            Popup.open(searchUrl, '', 900, 700)
          else {
            this.notify({
              color:'primary',
              title: this.$t('dash.posts.error.title'),
              text: this.$t('dash.post.linkedin.error_show_post'),
              time: 4000,
              id: null
            })
          }
        })
      }
    },

    openYoutube(entry){
      Popup.open(`https://www.youtube.com/watch?v=${entry.page[0].post_number}`, '', 900, 700)
    },
  }
}
</script>
